var Base = require('./_BasePartial'),
    scope = require('scope'),
    View =  Base.extend({
        name: "parents",
        template: require('templates/elements/parents.hbs'),
        behaviors: {
        },
        partials: {
        },
        ui: {
        },
        events: {
        },
        onAttach: function(){
            console.log('attach ' + this.name);
        }
    });
module.exports = View;



// WEBPACK FOOTER //
// ./resources/scripts/partials/Parents.js